import { isEqual } from 'lodash'
import { Moment } from 'moment'
import { useWatch } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { selectAssetDetailPage } from 'store/asset/selectors'

import { FIELD_NAMES } from '../validation'

export const useResidualUsagePeriodDefault = (usagePeriodMonths?: number | null) => {
  const impairmentAt = useWatch<Moment>({ name: FIELD_NAMES.impaired_at })
  const { asset } = useSelector(selectAssetDetailPage, isEqual)

  if (!asset.usage_started_at || !impairmentAt || !usagePeriodMonths) return 1

  const numberMonths = impairmentAt?.diff(asset.usage_started_at, 'months')

  return Math.min(Math.max(1, usagePeriodMonths - numberMonths), 36)
}
